import { gql } from "@apollo/client";

export const cameraBulkCommandsQuery = gql`
    query CameraBulkCommandsAdmin($page: Int, $sort: SortInput, $status: CameraBulkCommandStatus) {
        cameraBulkCommandsAdmin(page: $page, sort: $sort, status: $status) {
            nodes {
                id
                createdAt
                executedBy
                sentAt
                finishedAt
                status
                camera {
                    id
                    name
                }
            }
            totalCount
            nextPage
            previousPage
            totalPages
        }
    }
`;
